import { variant } from 'styled-system';

const types = () =>
  variant({
    prop: 'type',
    variants: {
      link: { color: 'brandPrimary.1' },
      positive: { color: 'positive.default' },
      negative: { color: 'negative.default' },
    },
  });
export default types;
